export default __webpack_public_path__ + "89fd46d94c67afad605c150d55f5a7f6.png";